<template>
    <v-row class="fill-height">
        <v-col>
            <v-card
                flat
            >
                <v-card-text>

                </v-card-text>

                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="finances.items"
                    :options.sync="options"
                    :server-items-length="finances.totalItems"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    item-key="id"
                    class="elevation-1"
                    v-show="finances.items"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                      }"
                >
                    <template v-slot:item.requestDate="{ item }">
                        {{ item.requestDate | formatDate3 }}
                    </template>
                    <template v-slot:item.valueReleased="{ item }">
                        {{ item.valueReleased | money }}
                    </template>
                    <template v-slot:item.valueAnticipation="{ item }">
                        {{ item.valueAnticipation | money }}
                    </template>
                    <template v-slot:item.totalValue="{ item }">
                        {{ item.totalValue | money }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{ name: 'financialView', params: { id: item.id } }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>
                    <!-- <template v-slot:item.actions="{ item }">
                         <v-tooltip bottom>
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn
                                     icon
                                     class="btn-lyndus"
                                     v-bind="attrs"
                                     v-on="on"
                                     :to="{ name: 'usersEdit', params: { id: item.id } }"
                                 >
                                     <v-icon>mdi-pencil</v-icon>
                                 </v-btn>
                             </template>
                             <span>Editar</span>
                         </v-tooltip>
                     </template>-->
                </v-data-table>
            </v-card>


        </v-col>
    </v-row>
</template>

<script>
import {mask} from "vue-the-mask";
import {mapGetters} from "vuex";
import store from "@/store";

import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";

import { FINANCE_CREATE, FINANCE_SEARCH
} from "@/store/actions/financial.type";
import {
    FINANCIAL_RESET_STATE,
    SET_FINANCE_PAGINATION
} from "@/store/mutations/financial.type";

export default {
    name: "financial",
    directives: {mask},
    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.commit(FINANCIAL_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        await store.commit(FINANCIAL_RESET_STATE);
        await store.dispatch(FINANCE_SEARCH);

        return next();
    },
    data: () => ({
        textRules: [
            (v) => !!v || "Este campo é obrigatório",
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        sortBy: 'requestDate',
        sortDesc: true,
        selected: [],
        options: {},
        headers: [
            {text: "Data", align: "left", value: "requestDate"},
            {text: "Saldo Liberado", value: "valueReleased"},
            {text: "Valor Antecipado", value: "valueAnticipation"},
            {text: "Valor Total", value: "totalValue"},
            // {text: "Usuário", value: "username"},
            {text: "Visualizar", value: "actions", sortable: false}
        ],
        tab: null,
        bankAccountIndex: null,
        localBanks: [],
        search: null,
        balanceRequestValue: 0,
        balanceRequest: {
            value: 0,
            valueReleased: 0,
            valueToReleased: 0,
            valueTotal: 0,
            valueRate: 0,
            bankID: 0
        },

        formIsValid: false,
        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 9,
            precision: 2
        },
        active: false,
        btnBalanceCheck: true,

        dialogRescueBalance: false,
        dialogBalance: false,
        dialogBankAccount: false,


        dialogBankRemove: false,
        socialEdit: false,
        updateLogo: null,


        social: {
            socialID: 0,
            url: "",
        },

        balance: {
            socialID: 0,
            url: "",
        },
        subtitle: {
            socialID: 0,
            url: "",
        },

        pixRules: [
            v => !!v && !!this.bankAccount.bank && this.bankAccount.agency && this.bankAccount.account || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],


    }),

    methods: {
        rescueRules(v) {
            let n = parseFloat(v.replace(".", "").replace(",", "."))
            if (isNaN(n)) return "Informe um valor válido ";

            if (n < 1) return "O Valor Mínimo é de R$ 1,00";

            if (this.finance.balanceTotal < n) return "O Valor informado é maior que o Saldo Total";

            return true
        },
        bankRulesValid(v) {
            if (!this.bankAccount.chavePIX) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        pixRulesValid(v) {
            if (!this.bankAccount.bank && !this.bankAccount.agency && !this.bankAccount.account) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },




        removeBankDialog(id, index) {
            this.dialogBankRemove = true;
            this.bankAccount.id = id
            this.bankAccountIndex = index
        },
        dialogRescueBalanceDialog() {

            this.dialogRescueBalance = true;
            for (let i = 0; i < this.bankAccounts.length; i++) {
                if (this.bankAccounts[i].default) {
                    this.balanceRequest.bankID = this.bankAccounts[i].id
                    return
                }
            }

        },
        loadExtract() {
            this.buscar()
        },
        async buscar() {
            const {sortBy, sortDesc, itemsPerPage, page} = this.options

            store.commit(SET_FINANCE_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0]
            })
            await store.dispatch(FINANCE_SEARCH);
        },
        async rescueBalance() {

            this.dialogRescueBalance = false;

            await this.$store
                .dispatch(FINANCE_CREATE, this.balanceRequest)
                .then(response => {
                    this.$store.commit(CHANGE_PROGRESS, false);

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Salvo com sucesso";

                    this.$refs.formBalanceRescue.reset()
                    this.$router.push({
                        name: "financialView",
                        params: {id: response.data.id}
                    });
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao Salvar";
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro ao salvar: " + response.data.message;
                    }
                });


        },

        //Dialog Balance - Botão Liberar Saldo

        closeBalance() {
            this.$refs.formBalance.resetValidation();
            this.socialEdit = false;
            this.dialogBalance = false;
            this.social.socialID = null;
            this.social.url = "";
        },


        //Dialog Bank Account - Botão Adicionar (Conta)
        closeBankAccount() {
            this.$refs.formBankAccount.resetValidation();
            this.socialEdit = false;
            this.dialogBankAccount = false;
            this.social.socialID = null;
            this.social.url = "";
        },


    },
    watch: {
        search(val) {
            val && val !== this.select && this.querySelections(val)
        },

        options: {
            handler() {
                this.buscar()
            },
            deep: true,
        },
    },
    computed: {
        ...
            mapGetters(["snackbar", "finances", "financePagination"]),
    }
    ,
}
;
</script>